module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("TWO")])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("K")])]), _vm._v("it breathed in the fresh soapy smell of Shane’s rich chocolate-colored hair. This wasn’t fair, the way he held her in his arms with an aloof possession. This wasn’t fair, the way her heart hurt from missing Jacob so much, the way her heart fluttered to life each time Shane bent his head and held her gaze with icy blue eyes, while he tried to search for all her secrets.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She wished her father hadn’t hired this particular man, wished her husband was still alive to dance with her, and wished she could just run away to some quiet island and grieve, really grieve, for all she’d lost the day her husband had died. But a Barton had to be strong; a Barton showed no grief. And so she was expected to carry on. Duty called. And only manners kept her from doing exactly that—up and running out of this room. And away from this man.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Am I making you uncomfortable?” he asked, his British accent precise and crisp in her ear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you think?” she shot back, looking up at him. “People are staring.” Even her parents had stopped chatting to watch them move around the dance floor.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("He dipped his head, his breath tickling against her ")]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("earlobe. “We could go somewhere more private so we can discuss my concerns for your safety.”")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Nice try,” she said, lifting away. “But I need to stay here with the people who paid a hefty sum to get in this room tonight, sorry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He slid a glance around the room. “That’s perfectly all right by me, Mrs. Atkins. Less danger in a crowd. But sooner or later, we will need to talk about your father’s instructions.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kit could agree with that, but not right now. “Sooner or later, we’ll do that, maybe over a nice cup of tea,” she said. “Just not tonight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Apparently, he didn’t like her response. “You are aware that you might be in danger, right?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Very aware.” But the only danger she could see right now was the man dancing with her. No doubt, it was unwise to be alone with Shane Warwick. So she played her part and carried on until she could figure out what to do next.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Call me Kit,” she said, wondering why she’d decided to give him that liberty. “And I hate crowds, but I can’t leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He smiled at that. “So you force yourself to do this, anyway? Because you believe in what you do even though events like this are sometimes tedious but necessary.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Surprised that he got her, she nodded. “Yes. I’m a rather shy, private person but I learned a long time ago I can’t live that way. And I won’t hide away like a coward, no matter what you and my father think. And no matter how big the crowd, and no matter the situation.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("He studied her as they glided around the room. “I’m aware of the crowd, and very much aware of the ")]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("situation. Heads are turning, whispers are surfacing, but that’s not my concern right now.”")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Well, it is mine,” she replied. “People will talk.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And you don’t want them to, right? So what? The cool, elegant, tragic widow is dancing with a mysterious stranger. And right here in Austin, at that. Scandalous, but maybe exactly what you need right now. People need to think you have a new suitor.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Anger flashed through Kit. Did she seem that sad and pathetic? “I’m not that tragic, thank you. And I have to walk a thin line, to protect the organization I’ve worked so hard to build through the years, so you can’t possibly know what I need.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The intimate look he gave her made her think he might know something about need himself, but right now, he didn’t dare voice that—not out loud and to her face. His job was to convince her that she needed him for protection against something she couldn’t even see in front of her. Something she didn’t want to see. She only wanted to continue her work. And continuing this dance without guilt or worry of scandal might be nice, too, for a change.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He dropped the charm, almost startling her with the lightning fast way he’d changed. “Right now, I know that you need to take "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this")]), _vm._v(" situation very seriously. You’re in danger and I’m here to keep you out of harm’s way.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kit’s heart did a long shudder, fear tickling through her like a whispering warning for the first time tonight. “Why won’t my father discuss this with me, so I can understand?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("“It’s too complicated.” He watched her for a minute, his icy eyes softening and never leaving her face. “There’s been some chatter. Some of the threats you ")]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("received were becoming very pointed and suggestive. And we’ve examined your home and office, based on files that have gone missing. It’s enough to make Gerald think there’s a need to be cautious. That’s all you should know.”")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lifted her chin. “I get that same line from my father. You know, I might be more willing and cooperative if someone would simply tell me what’s going on. How can I be cautious if I don’t know what I’m running from?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good point.” He looked at her with regret when the music ended. “Why don’t we go sit down and I’ll try to explain.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She checked her watch. “I have to give a thank-you speech in about fifteen minutes, Mr. Warwick.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s Shane,” he replied, his smile back in let’s pretend mode. “And not to worry on that account. I will be a perfect gentleman at all times and you can escape to give your speech without missing a beat. You have my word on that.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kit believed him, and to her ultimate aggravation, was almost a little disappointed to cave so easily. Trudy was right about Shane Warwick. He knew how to wear a tuxedo. The man exuded cool, calm, collected and charming. Lethal qualities to tempt a woman who missed the closeness of marriage and a husband. But easing her loneliness wasn’t why Shane Warwick was here.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her powerful father had ordered him to watch over her. And Gerald Barton could pay for the best in everything, including bodyguards. She could rest easy in that assurance at least. Even if she probably wouldn’t sleep a wink tonight when she finally made it home.")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We can take that table in the far corner by the orchestra,” she told him, her gaze moving through the crowd. “We shouldn’t be interrupted there.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Good,” Shane said, his approval telling her they’d also be safer there. “I’ll get you settled and fetch us something to drink. Are you hungry?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No.” She couldn’t eat a bite if her life depended on it. Then she remembered why Shane was here. Her life might depend on following his orders, whether she wanted to or not. Dropping her defiance for now, she allowed him to guide her to their table.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The eyes of everyone in the room followed them with clear interest and curious speculation.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane set down their drinks and a plate of canapés then pulled out the chair across from her. The vase of red roses on the stark white brocade tablecloth added a sense of drama to their meeting. He’d taken on this job and now he had to do his best to convince the subject at hand that she needed to listen to reason. And, he decided on the spot, he hoped he could make her smile again in the process of getting acquainted with her.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane didn’t know which part of his task would be the most difficult—keeping her safe or removing her mantle of grief. He hated the look of despair that came into her eyes when she didn’t think anyone was watching. But he was paid to observe and paid to pick up on the slightest of nuances.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And right now, as he watched Kit from across the tiny table, he saw a woman who hid her emotions and her fears behind the aura of grace and style and proper grooming.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("His mother, British-bred and born, would highly ")]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("approve of Katherine Atkins. But Lady Samantha wasn’t here tonight, thankfully. He didn’t need her playing matchmaker while he was on the clock. No, his dear mother was safely ensconced in their country home near London, entertaining a group of pretentious, titled friends who moved in royal circles. And having the time of her life doing it, he imagined.")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re grinning,” Kit said, her exquisite eyebrows lifting like a butterfly’s wings. “Is this amusing to you?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He shook his head. “I was thinking about my mother, actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kit slanted her head. “That’s not very complimentary of me, now is it? We’re finally alone and you’re thinking about your mother?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He liked her sense of humor. “Trust me, luv, it was a passing thought. I was thinking how she’d love to meet you. She loves all things Texas, so much so that she married a Texan—my father was born and raised near Dallas. We still have property just outside Fort Worth.” His smile tipped up into a grin. “And she named me after a movie—that Wyoming western "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Shane")]), _vm._v(". I’m surprised she didn’t name me Dallas, but my father loved that particular movie. Watched it all the time.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kit leaned forward. “Well, I didn’t know all of that. But you’re so—”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“British?” he asked, following her body language and leaning forward a bit himself. “That I am. My mother’s British with a lineage that dates back to Queen Elizabeth—the first Queen Elizabeth, that is.” He shrugged. “My parents met on a cruise to Africa, went on safari together and well, as you said earlier, the rest was written in the stars. A true love match.”")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She lifted away, clearly uncomfortable with any talk of love matches. “Did your father move to England, then?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes and no. They lived there part of the time and here part of the time by mutual consent, and sometimes they even lived apart by mutual consent, but I attended school in England and spent most of my youth there, per my mother’s request.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“And how did your father feel about that?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He brought me here during school breaks and the summers so we could hunt and fish and do manly things. Just so I’d have a well-rounded life, you understand.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I do understand. Texas is so vast, we can all acquire a well-rounded life here. Even an Englishman.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His grin turned impish. “I think my mother would agree with you on that. She did spend a great deal of time in Texas when they were dating. Especially when he was trying to convince her to marry him. She said she almost backed out after meeting his loud, crude, slightly crazy family. But she grew to love them, one and all.” He touched a rose petal and watched it fall to the table. “And she loved my father. Their time together wasn’t always happy, though. I think they needed their spots of separation.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She frowned. “I thought you said it was a love match.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I did and it was. But all good things take time and compromise, or as my mother calls it—mutual consent and mutual respect.” He looked at her, her eyes, her lips, her long, elegant throat, that enticing strand of perfect pearls. “But some things can be worth the wait.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("Kit, following the line of his gaze, toyed with her ")]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("pearls. “So she didn’t give in at first, even though she was in love with him?”")])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane saw the interest in her pretty green eyes. And a bit of sadness. She was a romantic then. “No, he used to say he chased her until she let him catch her. And she used to say that she had him wrapped around her finger, but she just wanted to make sure he sweated a little before she said yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What a charming story.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane nodded, took a sip of his drink. “My father, William, died a few years ago. So now, it’s hard for Lady Samantha to come to Texas. It reminds her too much of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Kit put her elbow on the table then dropped her chin onto her upturned hand, making her look more like a fresh-faced debutante than an attractive, mature woman. “I can certainly understand that feeling. Sometimes, I’d like to get out of this state myself.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane noted that. “I’m sorry for your loss. From what I’ve heard, your husband was a good man.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She blinked, realized she wasn’t sitting up properly and just like that, her spine went ramrod straight, no longer touching the back of her chair, while the curtain on her emotions came down with a feminine sigh and an elegant lifting of her chin. “Thank you. Now let’s talk about why you’re here and what I need to do to make this as unobtrusive as possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane put his hand on his heart. “Unobtrusive? You want "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("me")]), _vm._v(" to be unobtrusive?” She didn’t need to know that he was an expert at sneaking in and out of most places completely undetected.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_vm._v("She actually laughed and the sound of it flowed over Shane’s highly aware nerve endings like delicate bells ")]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("moving through a warm wind. “What? You’ve never tried being that way before?”")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Not in my arsenal, I’m afraid. I prefer to operate on the principle of hiding in plain sight. I like to be out there, very visible, but very aware. My plan is to be seen with you a lot, so that the society ladies who love to gossip over lunch at the club or while hitting tennis balls back and forth on the court, will take notice and spread the word. I want us to be seen as an item.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your premise being?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My premise being that an attached woman is much safer than a single, alone woman.” He shrugged. “And besides, it will make my job that much easier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Her eyes went dark again. “I am single and alone and I’ve learned to live with that, regardless of making your life easier.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane hated himself for making her think along those lines but it was necessary for her safety. “All the more reason to seem involved. My presence could throw off a potential enemy.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Or invite that enemy to fight to the finish.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I see you know more about your father’s work than you let on.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, more than I want to know.” She pushed at her immaculate upswept white-blond hair. “I don’t like living this way. I don’t want to walk around in fear.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You won’t have to if I’m with you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“But how long will this ploy work? Are you prepared to stay by my side all the time, even when I leave the country?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("His pulse quickened at that. “Especially if you leave the country—make that—if you’re "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("allowed")]), _vm._v(" to leave the country. I have my orders.”")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Of course you do. And I like my privacy and my dignity, and I won’t be told what I can and can’t do. So I don’t intend to be part of some facade or deception. It’s not right.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It is right if it means saving your life, Katherine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She stood up, dismissing him in a shimmer of silk and a whiff of lily-scented perfume. “That’s the CHAIM way, isn’t it? Always. Might makes right. All for the good fight, the good cause. Do you ever get tired of all the secrecy and the conspiracy?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane almost answered yes to that question. Yes, he did get tired, of war, of the horrors of injustice, of all that he’d seen in his covert travels around the planet, but he’d joined this organization after his father had introduced him to Gerald Barton. They’d both seen something in Shane that he hadn’t even seen in himself. A restless need to avenge good people, to help save lives when innocence clashed with evil, when good men had to fight ruthless criminals that no amount of man’s law could stop. He’d been trained from birth to hunt, shoot, and fight like a gentleman—at his mother’s insistence, but with his father’s help, he’d learn how to think like a combination street gang fighter and gunslinger, with purposeful intent and take-no-prisoners determination. And even though he might sometimes have to get down and dirty to do his job, he worked to fight the good fight and he believed in saving lives, not taking them. So he looked up at Katherine Atkins and said nothing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Your silence speaks volumes,” she said, whirling to leave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane was up and by her side in a flash. “There are some things a lady doesn’t need to hear.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("She glared up at him, her eyes a sea of unfathomable ")]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("green. “And there are some things a gentleman should tell a lady. Such as what kind of danger she is in and why? But your loyalty lies with my father and CHAIM, right? So I can’t count on you to tell me the truth.”")])]), _c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He moved in front of her, blocking her way while those curious gazes all around the room stayed centered on them. They’d make the society columns tomorrow and that would work just fine with their cover. “You can count on me to protect you, to give my life for you if necessary. That is my job.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t you think you’re being a bit overly dramatic?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t you think you could possibly avoid making a scene and listen to reason?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She looked around, realizing much too late that the room had grown quiet, that the orchestra was on a break. The music had stopped and all eyes were on the two of them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“This is your fault,” she said just as a camera’s flash blinded her. “Great, now you’ve brought out the paparazzi, too. So much for hiding in plain sight.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Shane trained his eyes on the person who’d taken that picture and that’s when he saw it. Just a flash in the crowd, a quick bit of action that seemed entirely out of place. There behind the roving photographer, a man dressed as a waiter stood silent and still near an exit on the other side of the orchestra stage, not far from where they were. Shane directed his gaze to the man holding the linen napkin across one arm and saw in that one second, as his gaze locked with the other man’s, that the man had a gun trained on Katherine.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page28"
    }
  }, [_vm._v("In a move that he’d remember later as pure adrenaline, Shane pushed Katherine to the floor behind the ")]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_vm._v("table, threw himself down to shield her and screamed at the top of his lungs, “Everyone down. Now!”")])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("A rush of panic hit the room and then bullets started flying all around them. Chaos took over as people either ducked or ran for the nearest exit. But there in the corner behind the protection of a flimsy table, Shane held Katherine’s trembling body close to his, his heartbeat racing to match hers, his prayers asking for protection as he tried to get a line on the shooter crouching near the big stage.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Speaking with shouted emphasis into his earpiece, he called for backup, his gaze never leaving the determined shooter. In spite of the shouts, screams and confusion all around them, the man crouched and moved with purposeful intent, weaving between chairs and tables to finish the job.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("And Katherine was the target.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t move,” he whispered into Katherine’s ear. “We’re going to get you out of here, just hold on.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Then he reached for the Glock semi-automatic pistol he was carrying in a shoulder holster underneath his tuxedo.")])])]), _c('a', {
    attrs: {
      "id": "page29"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page29"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343cf2a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781426865084_ch02.vue
// module id = 84
// module chunks = 0